// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"2de64650","305":"2b7a1710","355":"7fba83b6","665":"86ce64b2","684":"4d51532b","863":"0a404c56","967":"84c58756"}[chunkId] + ".chunk.js";
};